import { createFlightTestCrewAccount, createSignatoryAccount, disableUser, impersonateUser, setDesignChangeFilter, setTenantClass, updateUser } from "../../Home/UserManager/actions";

import ItemListView from "../../../components/ItemListView/ItemListView.vue";
import ItemView from "../../../components/ItemView/ItemView.vue";
import { activatePendingInternal } from "../../Home/UserManager/actions";
import { addUser } from "../../Home/UserManager/actions";
import { canActivatePendingInternal } from "../../Home/UserManager/pendingInternalActivation.common.js";
import { get } from "lodash";
import security from "../../Home/UserManager/attachable";

export default [{
    "path": "/Admin/Users",
    "component": { ...ItemListView },
    "name": "Users",
    "meta": {
        "name": "Users",
        "app": "Admin",
        "appSwitcher": true,
        "appSwitcherPosition": 20,
        "sideNav": true,
        "sideNavPosition": 1,
        "sideNavSection": "Admin",
        "icon": "shield-halved",
        "tableSettings": "UserManager",
        "dataPath": "users",
        "selectionRoute": "Admin/Users/{key}",
        "security": "General.UserAdmin",
        "menuActions": [],
        lock(user) {
            return [user?.Security?.General?.UserAdmin !== true, "Cannot view this area"]
        },
        // hidden(user) {
        //     return user?.Security?.General?.UserAdmin !== true;
        // },
        "menuActions": [{
            "label": "Add User",
            "action": addUser
        }, {
            "label": "Impersonate User",
            "action": impersonateUser,
            "break": true,
            hide({ store }) {
                return store?.state?.user?.Security?.General?.ApplicationAdmin !== true;
            }
        }, {
            "label": "Create Flight Test Crew (External Self-Service)",
            "action": createFlightTestCrewAccount,
            "break": true
        }, {
            "label": "Enable Signatory Self-Service (External)",
            "action": createSignatoryAccount
        }]
    }
}, {
    "path": "/Admin/Users/:id",
    "component": ItemView,
    "name": "User",
    "meta": {
        "app": "Admin",
        "name": "User",
        "sideNav": false,
        "appSwitcher": false,
        "dataPathOverride": "Userdata/:id",
        "selectionRoute": "Admin/Users/{ID}",
        "addToSettingsRecents": false,
        lock(user) {
            return [user?.Security?.General?.UserAdmin !== true, "Cannot view this area"]
        },
        title(item) {
            return `User: ${item?.Basic?.name}`
        },
        "dataFields": [{
            "label": "Name",
            "key": "Basic.name"
        }, {
            "label": "Email",
            "key": "Basic.email"
        }, {
            "label": "Department",
            "key": "Basic.department"
        }, {
            "label": "Position",
            "key": "Basic.job_title"
        }, {
            "label": "Manager",
            compute({ pageItem, store }) {
                if (!pageItem?.Basic?.ManagerID) return "No manager";
                else return get(store.state.users, `${pageItem.Basic.ManagerID}.name`, "No manager");
            }
        }],
        "menuActions": [{
            "label": "Update User",
            "action": updateUser
        }, {
            "label": "Activate Pending User",
            "action": activatePendingInternal,
            show(context) {
                return [canActivatePendingInternal(context), "Requires ApplicationAdmin and an inactive legacy pending account."];
            }
        }, {
            "label": "Set Tenant Class",
            "action": setTenantClass,
            "break": true
        }, {
            "label": "Specify Design Changes",
            "action": setDesignChangeFilter
        }, {
            "label": "Disable User",
            "action": disableUser
        }],
        "attachedItems": {
            "Security": {
                "attachables": security
            }
        }
    }
}];
